import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _taggedTemplateLiteral from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "/build/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import dayjs from "@/lib/day";
import { gql } from "@apollo/client";
import { createPageInfo } from "./helper";
export var typeDef = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  type ProductOrders @cacheControl(maxAge: 0) {\n    order_id: Int\n    name: String\n    created_at: String\n    order: OrderType\n    entitlements: [Entitlement]\n  }\n  type ProductOrdersResponse {\n    data: [ProductOrders]\n  }\n\n  type OrderType {\n    finished_at: String\n    payment_amount: Int\n    payment_instrument: paymentInstrumentType\n  }\n\n  type paymentInstrumentType {\n    payment_method_id: Int\n    values: paymentInstrumentValue\n  }\n\n  type paymentInstrumentValue {\n    card_type: String\n    card_number: String\n  }\n\n  type OrderData @cacheControl(maxAge: 0) {\n    name: String\n    payment_amount: Int\n    payment_instrument: paymentInstrumentType\n    created_at: String\n    order_type: String\n  }\n\n  type OrdersResult {\n    data: [OrderData]\n    pageInfo: PageInfo\n  }\n\n  type Query {\n    productOrders(\n      with_order: Boolean\n      with_payment_instrument: Boolean\n      with_entitlements: Boolean\n      type: String\n    ): ProductOrdersResponse\n\n    orders(offset: Int, limit: Int, adultFlag: Boolean): OrdersResult\n  }\n"])));
export var resolvers = {
  Query: {
    productOrders: function () {
      var _productOrders = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_parent, args, _ref) {
        var req, dataSources, result, now;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                req = _ref.req, dataSources = _ref.dataSources;
                _context.next = 3;
                return dataSources.orders.getProductOrders(args);

              case 3:
                result = _context.sent;
                now = dayjs();

                if (args.type === "is-entitled") {
                  result.product_orders = result.product_orders.filter(function (element) {
                    var _element$entitlements, _element$entitlements2, _element$entitlements3, _element$entitlements4, _element$entitlements5, _element$entitlements6;

                    if (element.product.values.adult_flag === req.adultMode && (element === null || element === void 0 ? void 0 : (_element$entitlements = element.entitlements) === null || _element$entitlements === void 0 ? void 0 : _element$entitlements.length) !== 0 && !(element !== null && element !== void 0 && (_element$entitlements2 = element.entitlements) !== null && _element$entitlements2 !== void 0 && (_element$entitlements3 = _element$entitlements2[0]) !== null && _element$entitlements3 !== void 0 && _element$entitlements3.end_at)) {
                      return true;
                    } else if (element.product.values.adult_flag === req.adultMode && (element === null || element === void 0 ? void 0 : (_element$entitlements4 = element.entitlements) === null || _element$entitlements4 === void 0 ? void 0 : _element$entitlements4.length) !== 0 && element !== null && element !== void 0 && (_element$entitlements5 = element.entitlements) !== null && _element$entitlements5 !== void 0 && (_element$entitlements6 = _element$entitlements5[0]) !== null && _element$entitlements6 !== void 0 && _element$entitlements6.end_at) {
                      var _element$entitlements7, _element$entitlements8;

                      return dayjs(element === null || element === void 0 ? void 0 : (_element$entitlements7 = element.entitlements) === null || _element$entitlements7 === void 0 ? void 0 : (_element$entitlements8 = _element$entitlements7[0]) === null || _element$entitlements8 === void 0 ? void 0 : _element$entitlements8.end_at).isAfter(now);
                    }
                  });
                }

                return _context.abrupt("return", {
                  data: result.product_orders
                });

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function productOrders(_x, _x2, _x3) {
        return _productOrders.apply(this, arguments);
      }

      return productOrders;
    }(),
    orders: function () {
      var _orders = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_parent, args, _ref2) {
        var dataSources, res;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                dataSources = _ref2.dataSources;
                _context2.next = 3;
                return dataSources.user.userOrders(args);

              case 3:
                res = _context2.sent;
                console.log("orders", res);
                return _context2.abrupt("return", {
                  data: res.orders,
                  pageInfo: createPageInfo(_objectSpread(_objectSpread({}, args), {}, {
                    count: res.total_count
                  }))
                });

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function orders(_x4, _x5, _x6) {
        return _orders.apply(this, arguments);
      }

      return orders;
    }()
  }
};